import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { type ReactElement } from "react";

import { Button } from "../../components/Button";

interface ScormPlayerHeaderProps {
  courseName: string;
  onBack: () => void;
}

export function ScormPlayerHeader(props: ScormPlayerHeaderProps): ReactElement {
  const { courseName, onBack } = props;

  return (
    <Stack
      direction="row"
      sx={(theme) => ({
        padding: theme.spacing(1.5),
        paddingX: theme.spacing(2),
        background: theme.palette.primary.main,
        justifyContent: "space-between",
        alignItems: "center",
        flexShrink: 0,
      })}
    >
      <Stack direction="row" sx={{ alignItems: "center", gap: 3 }}>
        <Button
          variant="text"
          size="small"
          sx={(theme) => ({
            color: theme.palette.primary.contrastText,
            textTransform: "none",
            whiteSpace: "nowrap",
            minWidth: "auto",
            padding: theme.spacing(0.5, 1),
          })}
          onClick={onBack}
        >
          &larr; Back
        </Button>
        <Text
          inline
          variant="body2"
          sx={(theme) => ({
            color: theme.palette.primary.contrastText,
            opacity: 0.8,
            borderLeft: `1px solid ${theme.palette.primary.contrastText}`,
            borderLeftColor: `${theme.palette.primary.contrastText}30`,
            paddingLeft: 2,
          })}
        >
          {courseName}
        </Text>
      </Stack>
    </Stack>
  );
}
